export var DateFrequency;
(function (DateFrequency) {
    DateFrequency["Yearly"] = "yearly";
    DateFrequency["Quarterly"] = "quarterly";
    DateFrequency["Monthly"] = "monthly";
    DateFrequency["Weekly"] = "weekly";
    DateFrequency["Daily"] = "daily";
})(DateFrequency || (DateFrequency = {}));
//# sourceMappingURL=dateFrequency.js.map